export default class AutoFillingRule {
  static generateActivitiesUuid = claim => claim.activities.map((activity) => {
    const newActivity = activity;
    Object.keys(newActivity).forEach((key) => {
      if (typeof newActivity[key] === 'number') {
        newActivity[key] = newActivity[key].toFixed(2);
      }
    });

    return {
      ...newActivity,
      id: Math.random(),
      code: activity.code,
    };
  });
}
